module.exports = __webpack_public_path__ + "static/media/intro.b5e7ecaf.mp3";